import styled from '@emotion/styled';

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  > button {
    flex: 40% 1 0;
    height: 56px;
    margin: 0;
    font-size: 14px;
    line-height: 15px;
    font-weight: 600;
    &:nth-of-type(2) {
      margin-left: 12px;
    } 
  }
  @media ${props => props.theme.mobile} {
    flex-wrap: wrap-reverse;
    > button {
      flex-basis: 100%;
      &:nth-of-type(2) {
        margin: 0 0 16px;
      } 
    }
  }
`;

export default ButtonContainer;
